import * as React from "react";
import Head from "next/head";
import CookieConsent from "react-cookie-consent";
import Analytics from "./Analytics";
import { getCookie } from "../lib/getCookie";

export default function CookiesBanner() {
  const [cookiesAccepted, setCookiesAccepted] = React.useState(false);

  React.useEffect(() => {
    const cookieGA = getCookie("cookies_settings");
    if (cookieGA === "true") {
      setCookiesAccepted(true);
    } else {
      setCookiesAccepted(false);
    }
  }, []);

  return (
    <>
      {cookiesAccepted ? (
        <Analytics />
      ) : (
        <Head>
          <link rel="icon" type="image/ico" href="/la-lettre-de/favicon.ico" />
        </Head>
      )}
      <CookieConsent
        onAccept={() => setCookiesAccepted(true)}
        onDecline={() => setCookiesAccepted(false)}
        location="bottom"
        buttonText={<>Tout accepter</>}
        enableDeclineButton
        declineButtonText={<>Déclin</>}
        cookieName="cookies_settings"
        disableStyles={true}
        containerClasses="cookies-container"
        buttonWrapperClasses="cookies-buttons"
        contentClasses="cookies-inner"
      >
        <>
          Nous utilisons des cookies pour mieux faire fonctionner notre site, ce
          qui inclut des cookies analytiques et des cookies publicitaires. Pour
          plus d'informations, consultez notre{" "}
          <a href="https://badoo.com/fr/cookie-policy/" target="_blank">
            Politique des cookies.
          </a>
        </>
      </CookieConsent>
    </>
  );
}
